import { useSelector } from "react-redux";
import ProductInventoryAPICall from "src/service/ProductInventoryAPICall";

export function useProductInventoryStore() {
    const inventoryList = useSelector((state) => state.entities.model_ProductInventory.master_data)
    let data = {
        inventoryList
    };

    let fetch = {
        fetch_product_inventory_list: async (params) => {
            return await new ProductInventoryAPICall().getInventory(params, true)
        },
        fetch_farnell_inventory_detail: async (params) => {
            return await new ProductInventoryAPICall().getFarnellInventoryDetail(params.ERPPartNumber)
        },
        get_inventory_by_id: (id) => {
            return inventoryList && (inventoryList[id] || { qas: 0, quantity: 0 });
        }
    };
    let set = {
        set_stock_alert_notification: async (params) => {
            return await new ProductInventoryAPICall().setStockAlertNotification(params)
        },
    };

    return [data, fetch, set]
}